import {
  Box,
  Typography,
  Paper,
  Rating,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getRequest, server } from "../../config";
import moment from "moment";

const UserReviewsList = ({ serviceId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (serviceId) {
      fetchReviews();
    }
  }, [serviceId]);

  const fetchReviews = async () => {
    try {
      setLoading(true);
      const uri =
        server.uri +
        `user-reviews?filter={"where":{"serviceId":"${serviceId}"}}`;
      const reviewsData = await getRequest(uri);
      if (reviewsData) {
        setReviews(reviewsData);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!reviews || reviews.length === 0) {
    return (
      <Box sx={{ py: 3, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No reviews yet
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Customer Reviews ({reviews.length})
      </Typography>
      {reviews.map((review, index) => (
        <Paper
          key={review.id || index}
          sx={{
            p: 2,
            mb: 2,
            backgroundColor: "#f9fafb",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              {review.customer?.name || "Anonymous"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {review.createdAt ? moment(review.createdAt).format("MMM DD, YYYY") : ""}
            </Typography>
          </Box>

          <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
            <Rating
              value={Math.min(Number(review.customer?.rating) || 0, 5)}
              readOnly
              size="small"
              precision={0.5}
              max={5}
            />
            <Typography variant="body2" fontWeight="bold">
              {Number(review.customer?.rating || 0).toFixed(1)}
            </Typography>
          </Box>

          {review.customer?.comment && (
            <Typography variant="body2" color="text.secondary">
              {review.customer.comment}
            </Typography>
          )}

          {review.partner && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <Box>
                <Typography variant="caption" fontWeight="bold" color="primary">
                  Partner Response:
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                  <Rating
                    value={Math.min(Number(review.partner?.rating) || 0, 5)}
                    readOnly
                    size="small"
                    precision={0.5}
                    max={5}
                  />
                  <Typography variant="body2" fontWeight="bold">
                    {Number(review.partner?.rating || 0).toFixed(1)}
                  </Typography>
                </Box>
                {review.partner?.comment && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {review.partner.comment}
                  </Typography>
                )}
              </Box>
            </>
          )}
        </Paper>
      ))}
    </Box>
  );
};

export default UserReviewsList;
